/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    AuthnContextUpdateChallenge,
    instanceOfAuthnContextUpdateChallenge,
    AuthnContextUpdateChallengeFromJSON,
    AuthnContextUpdateChallengeFromJSONTyped,
    AuthnContextUpdateChallengeToJSON,
} from './AuthnContextUpdateChallenge';
import {
    NonceChallenge,
    instanceOfNonceChallenge,
    NonceChallengeFromJSON,
    NonceChallengeFromJSONTyped,
    NonceChallengeToJSON,
} from './NonceChallenge';
import {
    OIDCChallenge,
    instanceOfOIDCChallenge,
    OIDCChallengeFromJSON,
    OIDCChallengeFromJSONTyped,
    OIDCChallengeToJSON,
} from './OIDCChallenge';
import {
    OTPChallenge,
    instanceOfOTPChallenge,
    OTPChallengeFromJSON,
    OTPChallengeFromJSONTyped,
    OTPChallengeToJSON,
} from './OTPChallenge';
import {
    PasswordResetChallenge,
    instanceOfPasswordResetChallenge,
    PasswordResetChallengeFromJSON,
    PasswordResetChallengeFromJSONTyped,
    PasswordResetChallengeToJSON,
} from './PasswordResetChallenge';
import {
    PasswordSetChallenge,
    instanceOfPasswordSetChallenge,
    PasswordSetChallengeFromJSON,
    PasswordSetChallengeFromJSONTyped,
    PasswordSetChallengeToJSON,
} from './PasswordSetChallenge';
import {
    PasswordVerifyChallenge,
    instanceOfPasswordVerifyChallenge,
    PasswordVerifyChallengeFromJSON,
    PasswordVerifyChallengeFromJSONTyped,
    PasswordVerifyChallengeToJSON,
} from './PasswordVerifyChallenge';
import {
    ProxyChallenge,
    instanceOfProxyChallenge,
    ProxyChallengeFromJSON,
    ProxyChallengeFromJSONTyped,
    ProxyChallengeToJSON,
} from './ProxyChallenge';
import {
    SAMLChallenge,
    instanceOfSAMLChallenge,
    SAMLChallengeFromJSON,
    SAMLChallengeFromJSONTyped,
    SAMLChallengeToJSON,
} from './SAMLChallenge';
import {
    TOTPRegisterChallenge,
    instanceOfTOTPRegisterChallenge,
    TOTPRegisterChallengeFromJSON,
    TOTPRegisterChallengeFromJSONTyped,
    TOTPRegisterChallengeToJSON,
} from './TOTPRegisterChallenge';
import {
    TOTPVerifyChallenge,
    instanceOfTOTPVerifyChallenge,
    TOTPVerifyChallengeFromJSON,
    TOTPVerifyChallengeFromJSONTyped,
    TOTPVerifyChallengeToJSON,
} from './TOTPVerifyChallenge';
import {
    UICustomizationChallenge,
    instanceOfUICustomizationChallenge,
    UICustomizationChallengeFromJSON,
    UICustomizationChallengeFromJSONTyped,
    UICustomizationChallengeToJSON,
} from './UICustomizationChallenge';
import {
    WebAuthnCreateChallenge,
    instanceOfWebAuthnCreateChallenge,
    WebAuthnCreateChallengeFromJSON,
    WebAuthnCreateChallengeFromJSONTyped,
    WebAuthnCreateChallengeToJSON,
} from './WebAuthnCreateChallenge';
import {
    WebAuthnGetChallenge,
    instanceOfWebAuthnGetChallenge,
    WebAuthnGetChallengeFromJSON,
    WebAuthnGetChallengeFromJSONTyped,
    WebAuthnGetChallengeToJSON,
} from './WebAuthnGetChallenge';

/**
 * @type ChallengeListInner
 * 
 * @export
 */
export type ChallengeListInner = { type: 'authn_context_update' } & AuthnContextUpdateChallenge | { type: 'nonce' } & NonceChallenge | { type: 'oidc' } & OIDCChallenge | { type: 'otp' } & OTPChallenge | { type: 'password_reset' } & PasswordResetChallenge | { type: 'password_set' } & PasswordSetChallenge | { type: 'password_verify' } & PasswordVerifyChallenge | { type: 'proxy' } & ProxyChallenge | { type: 'saml' } & SAMLChallenge | { type: 'totp_register' } & TOTPRegisterChallenge | { type: 'totp_verify' } & TOTPVerifyChallenge | { type: 'ui_customization' } & UICustomizationChallenge | { type: 'webauthn_create' } & WebAuthnCreateChallenge | { type: 'webauthn_get' } & WebAuthnGetChallenge;

export function ChallengeListInnerFromJSON(json: any): ChallengeListInner {
    return ChallengeListInnerFromJSONTyped(json, false);
}

export function ChallengeListInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeListInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'authn_context_update':
            return {...AuthnContextUpdateChallengeFromJSONTyped(json, true), type: 'authn_context_update'};
        case 'nonce':
            return {...NonceChallengeFromJSONTyped(json, true), type: 'nonce'};
        case 'oidc':
            return {...OIDCChallengeFromJSONTyped(json, true), type: 'oidc'};
        case 'otp':
            return {...OTPChallengeFromJSONTyped(json, true), type: 'otp'};
        case 'password_reset':
            return {...PasswordResetChallengeFromJSONTyped(json, true), type: 'password_reset'};
        case 'password_set':
            return {...PasswordSetChallengeFromJSONTyped(json, true), type: 'password_set'};
        case 'password_verify':
            return {...PasswordVerifyChallengeFromJSONTyped(json, true), type: 'password_verify'};
        case 'proxy':
            return {...ProxyChallengeFromJSONTyped(json, true), type: 'proxy'};
        case 'saml':
            return {...SAMLChallengeFromJSONTyped(json, true), type: 'saml'};
        case 'totp_register':
            return {...TOTPRegisterChallengeFromJSONTyped(json, true), type: 'totp_register'};
        case 'totp_verify':
            return {...TOTPVerifyChallengeFromJSONTyped(json, true), type: 'totp_verify'};
        case 'ui_customization':
            return {...UICustomizationChallengeFromJSONTyped(json, true), type: 'ui_customization'};
        case 'webauthn_create':
            return {...WebAuthnCreateChallengeFromJSONTyped(json, true), type: 'webauthn_create'};
        case 'webauthn_get':
            return {...WebAuthnGetChallengeFromJSONTyped(json, true), type: 'webauthn_get'};
        default:
            throw new Error(`No variant of ChallengeListInner exists with 'type=${json['type']}'`);
    }
}

export function ChallengeListInnerToJSON(value?: ChallengeListInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'authn_context_update':
            return AuthnContextUpdateChallengeToJSON(value);
        case 'nonce':
            return NonceChallengeToJSON(value);
        case 'oidc':
            return OIDCChallengeToJSON(value);
        case 'otp':
            return OTPChallengeToJSON(value);
        case 'password_reset':
            return PasswordResetChallengeToJSON(value);
        case 'password_set':
            return PasswordSetChallengeToJSON(value);
        case 'password_verify':
            return PasswordVerifyChallengeToJSON(value);
        case 'proxy':
            return ProxyChallengeToJSON(value);
        case 'saml':
            return SAMLChallengeToJSON(value);
        case 'totp_register':
            return TOTPRegisterChallengeToJSON(value);
        case 'totp_verify':
            return TOTPVerifyChallengeToJSON(value);
        case 'ui_customization':
            return UICustomizationChallengeToJSON(value);
        case 'webauthn_create':
            return WebAuthnCreateChallengeToJSON(value);
        case 'webauthn_get':
            return WebAuthnGetChallengeToJSON(value);
        default:
            throw new Error(`No variant of ChallengeListInner exists with 'type=${value['type']}'`);
    }

}

